export default __webpack_public_path__ + "static/media/pirate1.32bf04f0.png";